import PptxGenJS from 'pptxgenjs';

import { createSectionSlide } from './helpers/section_slide';
import { createTitleSlide } from './helpers/title_slide';
import { assertValidPresentation } from './model';
import { renderPresentationSlide } from './renderers';

const toRendererFooter = (footer = {}) => ({
  reportDateRange: footer.dateRange,
  reportType: footer.sourceLabel,
  reportUrl: footer.sourceUrl,
  shopperAttributes: footer.attributes,
});

/**
 * Validates and renders the canonical presentation model. Feature-specific parsing and data mapping
 * must happen before this boundary.
 *
 * @param {Object} options
 * @param {Boolean} [options.download=true]
 * @param {Object} options.model canonical PresentationModel
 * @param {Function} [options.pptxFactory]
 * @returns {Promise<Object>} PptxGenJS instance
 */
export const createPresentation = async ({
  download = true,
  model,
  pptxFactory = () => new PptxGenJS(),
}) => {
  assertValidPresentation(model);

  const pptx = pptxFactory();
  const footer = toRendererFooter(model.footer);
  createTitleSlide({
    pptx,
    reportName: model.title.heading,
    reportType: model.title.subtitle || '',
  });

  for (const section of model.sections) {
    if (section.title) createSectionSlide({ ...footer, pptx, title: section.title });
    for (const slide of section.slides) {
      // Image rendering may be async; preserve exact model ordering.
      // eslint-disable-next-line no-await-in-loop
      await renderPresentationSlide({ footer, pptx, slide });
    }
  }

  if (download) await pptx.writeFile({ fileName: `${model.fileName}.pptx` });
  return pptx;
};
